const external_routes = {
  painel: '/painel',
  boletins: '/boletim_web/public/boletins',
  licitacoes: '/banco_de_dados',
  acompanhamentos: '/banco_de_dados/acompanhamentos',
  meu_banco: '/meu_banco_de_dados',
  resultados: '/banco_de_dados/resultados',
  minhas_licitacoes: '/minhas_licitacoes/biddings',
  gerenciar_licitacoes: '/minhas_licitacoes/management',
  documentos: '/documentos',
  monitoramento: '/facilitadores/monitoramento',
  cursos: '/conlicita_go',
  academy: '/academy',
  contratos: '/contratos',
  assinatura_digital: '/assinatura_digital',
  dr_licita: '/dr_licita',
  dr_licita_create_document: '/dr_licita/document',
  ata_de_registro_preco: '/ata_de_registro_preco',
  meu_historico: '/meu_historico',
  iminencia: '/iminencia',
  robo_lance: '/robo_lance',
  gerenciar_portais: '/portais',
  analise_estrategica: {
    analise: '/mercado',
    concorrentes: '/concorrentes',
    contratos: '/contratos',
    ata_de_registro_preco: '/ata_de_registro_preco',
    meu_historico: '/meu_historico',
    pesquisa_de_precos: '/pesquisa_de_precos',
  },
  juridico: {
    assessoria_cadastral: '/assessoria_cadastral',
    juridico_facil: '/juridico',
    legislacoes: '/legislacao',
    artigos: 'https://conlicitacao.com.br/blog/',
    duvidas: '/consultoria_juridica',
  },
  mais: {
    certidoes: '/conteudo_exclusivo/certidoes_online',
    bolsa_empregos: '/conteudo_exclusivo/bolsa_de_empregos',
    clipping_policia_federal: '/conteudo_exclusivo/clipping_policia_federal',
    api: '/conlicitacao_api',
    status: '/tools_status',
  },
  usuario: {
    minha_conta: '/minha_conta/boletos_online',
    planos_precos: '/planos',
  },
  login: {
    portal: 'http://portal.conlicitacao.com.br',
    contato: 'https://conlicitacao.com.br/ajuda/#contato',
    esqueceu_senha: '/usuarios/password/new',
    cadastro:
      'https://portal.conlicitacao.com.br/cadastro-simples/?utm_source=pagina-login&utm_medium=banner&utm_campaign=cta-login',
  },
};

export default external_routes;
